export default "__VITE_PUBLIC_ASSET__b55cd8c2__"